export default "__VITE_ASSET__B2CZLEw3__"